<template>
    <div id="type-tag" class="type-tag">
        <!-- 考题类型 -->
        <span class="type-bg type-topic" v-if="type === 'topicType'" :class="getTopicTypeClass(id)">{{name}}</span>

        <!-- 考卷类型 -->
        <span class="type-bg type-paper" v-if="type === 'paperType'" :class="getPaperTypeClass(id)">{{name}}</span>

        <!-- 培训情况类型 -->
        <span class="type-bg type-train" v-if="type === 'trainType'" :class="getTrainTypeClass(id)">{{name}}</span>

        <!-- 直播状态 -->
        <span class="live-type"
              v-if="type === 'liveType'"
              :class="'live-status-'+id">
            <template v-if="id === 1">
                <img class="online-gif" src="~@/assets/images/live/on-play.gif" alt="playing gif">
                <span>{{ $t('live.living') }}</span>
            </template>
            <span v-if="id === 2">预告</span>
            <span v-if="id === 3">结束</span>
            <span v-if="id === 5">回放</span>
        </span>
    </div>
</template>

<script>

/**
 *   考题类型
 *   <type-tag type="topicType" :id="item.type" :name="item.typeName"></type-tag>
 *
 *   考卷类型
 *   <type-tag type="paperType" :id="row.type" :name="row.typeName"></type-tag>
 *
 *   培训情况类型
 *   <type-tag type="trainType" :id="row.type" :name="row.typeName"></type-tag>
 *
 *   直播状态
 *   <type-tag type="liveType" :id="row.status"></type-tag>
 *
 *   todo：其他，比如考试状态...用到再封装吧
 */

export default {
    props: {
        /**
         * 类型，包括 topicType、paperType
         */
        type: {
            type: String,
            required: true
        },
        id: {
            type: Number,
            required: true
        },
        name: {
            type: String,
            //required: true
        }
    },

    methods: {
        getTopicTypeClass(id) {
            let customClass =''
            switch (id){
                case 1:
                    customClass = 'single';
                    break;
                case 2:
                    customClass = 'multi';
                    break;
                case 3:
                    customClass = 'judge';
                    break;
                case 4:
                    customClass = 'match';
                    break;
                case 6:
                    customClass = 'ct';
                    break;
                case 5:
                    customClass = 'dr';
                    break;
                default:
                    customClass = 'single'
            }
            return customClass
        },

        getPaperTypeClass(id) {
            let customClass = ''
            switch (id) {
                case 1:
                    customClass = 'theory';
                    break;
                case 3:
                    customClass = 'ct';
                    break;
                case 4:
                    customClass = 'dr';
                    break;
                case 5:
                    customClass = 'fiscan';
                    break;
                default:
                    customClass = ''
            }
            return customClass
        },

        getTrainTypeClass(id) {
            return [
                'notStart',     //0 未开始
                'processing',   //1 进行中
                'finish',       //2 完成
                'absence',      //3 缺席
                'recover',      //4 恢复
            ][id]
        }
    },
}
</script>

<style lang="scss">
#type-tag {
    display: inline-block;
    .type-bg {
        display: inline-block;
        width: 80px;
        height: 24px;
        line-height: 24px;
        border-radius: 1px;
        color: #fff;
    }

    .type-topic {
        &.single{
            background-color: #ffb822;
        }
        &.multi{
            background-color: #2e7faa;
        }
        &.judge{
            background-color: #a17e68;
        }
        &.match{
            background-color: #5c765b;
        }
        &.ct{
            background-color: #0396a6;
        }
        &.dr{
            background-color: #f4516c;
        }
    }

    .type-paper {
        &.theory {
            background-color: #6a7881;
        }

        &.ct {
            background-color: #0396a6;
        }

        &.dr {
            background-color: #f4516c;
        }

        &.fiscan {
            background-color: #2e7faa;
        }
    }

    .type-train {
        &.status {
            background-color: #3572A0;
        }
        &.notStart {
            background-color: #2e7faa;
        }
        &.processing {
            background-color: #0396a6;
        }
        &.finish {
            background-color: #FFB822;
        }
        &.absence {
            background-color: #8c7b6c;
        }
        &.recover {
            background-color: #c47a76;
        }
    }

    .live-type {
        padding: 4px 12px;
        border-radius: 4px;
        font-size: 12px;
        color: #fff;

        &.live-status-1 {
            background: $color-theme;
        }
        &.live-status-2 {
            background: #fc5659;
        }
        &.live-status-3 {
            background: #999;
        }
        &.live-status-5 {
            background: #2ab804;
        }

        .online-gif {
            width: 10px;
            height: 10px;
            margin-right: 2px;
            vertical-align: baseline;
        }
    }
}
</style>
